<template>

<div class="container main-content">

	<div class="row text-center mb-5">
		<div class="col-12">
			<img src="./../assets/img/flexepin.png" class="img-fluid">
		</div>
	</div>

	<div class="row mb-5">
		<div class="col-12 text-center">
			<h4 class="dark-highlight mb-5">Enter Your Flexepin Voucher</h4>
			<input class="bitaddress form-control no-border-radius" 
				type="text" 
				onkeyup="this.value=this.value.replace(/[^\d]/,'')"
				maxlength="16"
				ref="flexepinCode" 
				required 
				:disabled="isProcessing"
				v-model="in_flexepinCode" 
				v-bind:class="{'is-invalid': hasError}">

			<small class="error" v-if="hasError">{{ errorMessage }}</small>
		</div>
	</div>
	<div class="row mb-5">
		<div class="col-12 text-center">
			<a href="#" id="payment-flexepin-next" class="btn next-btn" v-on:click.prevent="submitFlexepinCode" v-if="!isProcessing">NEXT</a>
			<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">{{ processingMsg }} <i class="fas fa-circle-notch fa-spin"></i></a>
		</div>
	</div>

	<div class="row panel-warning mt-4 mb-5 p-3">
		<div class="col-12 col-sm-1 text-center">
			<div class="exclamation" alt="Exclamation"></div>
		</div>
		<div class="col-12 col-sm-11 text-center text-warning">
			Flexepin vouchers are one time use only.  Once this voucher is used you will not have any remaining balance.
		</div>
	</div>

	<cc-modal v-if="showRequestNewQuoteModal" v-bind:confirm="true" @action="requestNewQuoteModalAction" no="Cancel">
		<p slot="body">{{ showRequestNewQuoteModalMsg }}</p>
	</cc-modal>

	<cc-modal v-if="showNewQuoteModal" :confirm="true" @action="newQuoteModalAction" no="Decline" yes="Accept &amp; Continue">

		<div slot="body">

			<p class="mb-4">Please review your updated quote.</p>
			<div class="row">
				<div class="col-12 col-sm-5 text-center no-padding">
					<div class="row">
						<div class="col-12 no-padding">
							<h4 class="new-quote-header">Amount</h4>
						</div>
					</div>
					<div class="row">
						<div class="col-12 no-padding">
							<span class="large-inputs-fiat new-quote-inputs">${{ newQuoteFiatAmount | num2decimal }}</span>&nbsp;<span class="large-inputs-suffix new-quote-large-inputs-suffix">{{ this.pq.fiatCurrency }}</span>
						</div>
					</div>
				</div>
				<div class="col-12 col-sm-2 no-padding mt-3 mt-sm-0 mb-3 mb-sm-0">
					<div class="convert-icon new-quote-convert-icon mb-2" alt="Convert"></div>
				</div>
				<div class="col-12 col-sm-5 text-center no-padding">
					<div class="row">
						<div class="col-12 no-padding">
							<h4 class="new-quote-header">Receive</h4>
						</div>
					</div>
					<div class="row">
						<div class="col-12 large-inputs-crypto">
							<span class="large-inputs-crypto new-quote-inputs">{{ newQuoteCryptoAmount | num8decimal }}</span>&nbsp;<span class="large-inputs-suffix new-quote-large-inputs-suffix">{{  this.pq.cryptoCurrency }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>

	</cc-modal>

</div>

</template>

<script>

import { eventBus } from './../main'

export default {
	data() {
		return {
			in_flexepinCode: '',
			hasError: false,
			errorMessage: '',
			showRequestNewQuoteModal: false,
			showRequestNewQuoteModalMsg: '',
			showNewQuoteModal: false,
			isProcessing: false,
			newQuoteFiatAmount: '',
			newQuoteCryptoAmount: '',
			newQuoteErrorMessage: '',
			showErrorModal: false,
			errorModalMsg: '',
			pq: this.$gstate.getFlowState(),
			newPq: null,
			processingMsg: 'Please wait...',
		}
	},
	mounted(){
		this.$refs.flexepinCode.focus();
	},
	created(){
		eventBus.$on('nextScreen', this.submitFlexepinCode);
	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.submitFlexepinCode)
	},
	methods: {
		startRedeem: function (){
			eventBus.$emit('pauseCountdown');

			this.hasError = false;

			// validate the iunput field
			if (!this.in_flexepinCode) {
				this.hasError = true;
				this.errorMessage = 'Please enter your Flexepin Voucher.'
				return;
			}

			if(isNaN(this.in_flexepinCode)){
				this.hasError = true;
				this.errorMessage = "Flexepin Vouchers are numbers only."
				return;
			}

			if(this.in_flexepinCode.length != 16){
				this.hasError = true;
				this.errorMessage = "Flexepin Vouchers are a 16 digits."
				return;
			}


			this.submitVoucher();
		},
		submitVoucher: function (){

			this.$gstate.log("Validating voucher.");
			this.processingMsg = "validating...";

			var urlstr = this.$gstate.getApiBaseURL() + '/vouchernumber';
			this.axios.post(urlstr,{
				refId: this.$gstate.getRefId(),
				voucherNumber: this.in_flexepinCode,
			}, this.$gstate.getAxiosHeaders() )
			// eslint-disable-next-line
			.then(response => {

				this.$gstate.log("Voucher is good.");

				this.isProcessing = false;
				this.$gstate.saveFlowStateAndProceed(response.data, this);
					
			})
			.catch(error => {
				this.$gstate.log("Validate voucher failed");
				this.handleFlexepinError(error);
			});
		},
		submitFlexepinCode: function() {
			
			this.startRedeem();

		},
		handleFlexepinError(error){
			this.$gstate.log("error:");

			this.isProcessing = false;
			this.hasError = true;

			if(error.response === undefined){
				this.errorMessage = "Lost connection.  Please try again.";
				return;
			}
			
			this.$gstate.log(error.response);
			eventBus.$emit('resumeCountdown');
			this.errorMessage = error.response.data.error.msg + ".";

			if(error.response.data.error.code == "TRANSACTION.AMOUNT.MISMATCH"){
				this.showRequestNewQuoteModal = true;

				this.errorMessage = "Flexepin voucher stored value does not match your quote.  Your stored value is $" + Number.parseFloat(error.response.data.errorParams.amount).toFixed(2) + " CAD";
				this.showRequestNewQuoteModalMsg = this.errorMessage + ".  Would you like to update your quote with this new amount?";

				this.newQuoteFiatAmount = error.response.data.errorParams.amount;

			} else if(error.response.data.error.msg == "Voucher is used"){
				this.errorMessage = "This voucher has already been used."
			}

		},
		requestNewQuoteModalAction(action){
			
			this.showRequestNewQuoteModal = false;
			
			if(action == 'yes'){
				
				// close this current pop up and open a new popup with the new amount being quoted
				this.isProcessing = true;
				this.hasError = false;
				
				var urlstr = this.$gstate.getApiBaseURL() + '/requote';
				this.axios.post(urlstr, {
					refId: this.$gstate.getRefId(),
					fiatAmount: this.newQuoteFiatAmount
				}, this.$gstate.getAxiosHeaders())
					// eslint-disable-next-line
					.then(response => {

						this.$gstate.log("Show the new quote.");
						this.$gstate.log(response);
						this.newPq = response.data;
						this.newQuoteCryptoAmount = response.data.cryptoAmount;
						this.showNewQuoteModal = true;

						this.$gstate.saveFlowState(response.data);
					
					})
					.catch(error => {

						this.$gstate.log("getting new quote has an error.");
						this.$gstate.log(error);
						this.hasError = true;
						this.errorMessage = error.response.data.error.msg;

					});

			} else {
				this.showNewQuoteModal = false;
			}
		},
		newQuoteModalAction(action){
			if(action == "yes"){

				/// ping the BE to accept the quote and then redirect to success page
				this.$gstate.log("confirmednewquote!")

				this.isProcessing = true;
				this.showNewQuoteModal = false;

				// in dev we need to force change the voucner or we're stuck in an infinite loop.
				if(this.$gstate.isDev()){
					this.in_flexepinCode = 6546465654654647;
				}

				this.submitVoucher();
				
			} else {
				this.showNewQuoteModal = false;
			}
		}
	}
}
</script>
